import { Modal, Progress, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const UploadProgressModal = ({
  visible,
  bulkProgress,
  bulkCurrent,
  bulkTotal,
}) => {
  return (
    <Modal
      title={
        <div style={{ textAlign: "center", fontSize: 18, fontWeight: "bold" }}>
          <Spin
            indicator={<LoadingOutlined style={{ fontSize: 24, marginRight: 10 }} spin />}
          />
          Processing Users...
        </div>
      }
      open={visible}
      footer={null}
      closable={false}
      maskClosable={false}
      width={600}
      centered
      className="upload-progress-modal"
    >
      <div style={{ padding: "20px 0" }}>
        {/* Main Progress Bar */}
        <div style={{ marginBottom: 30 }}>
          <Progress
            percent={bulkProgress}
            status="active"
            strokeWidth={39}
            strokeColor={{
              "0%": "#108ee9",
              "100%": "#68a0d0",
            }}
            strokeLinecap="round"
            format={(percent) => (
              <span style={{ fontSize: 18, fontWeight: "bold" }}>
                {percent}%
              </span>
            )}
          />
        </div>

        {/* Current Status Card */}
        <div
          style={{
            textAlign: "center",
            marginBottom: 25,
            padding: "25px",
            background: "linear-gradient(135deg, #667eea 0%, #4166cb 100%)",
            borderRadius: "16px",
            boxShadow: "0 8px 20px rgba(102, 126, 234, 0.4)",
            animation: "fadeInScale 0.5s ease-out",
          }}
        >
          <div style={{ marginBottom: 10 }}>
            <span
              style={{
                fontSize: 48,
                fontWeight: "bold",
                color: "#ffffff",
                textShadow: "0 2px 4px rgba(0,0,0,0.2)",
              }}
            >
              {bulkCurrent}
            </span>
            <span
              style={{
                fontSize: 32,
                color: "#e0e0e0",
                margin: "0 10px",
              }}
            >
              /
            </span>
            <span
              style={{
                fontSize: 32,
                color: "#e0e0e0",
              }}
            >
              {bulkTotal}
            </span>
          </div>
          <p
            style={{
              fontSize: 16,
              margin: 0,
              color: "#ffffff",
              opacity: 0.9,
            }}
          >
            Users Processed
          </p>
          <p
            style={{
              fontSize: 14,
              margin: "8px 0 0 0",
              color: "#e0e0e0",
            }}
          >
            {bulkTotal - bulkCurrent} remaining
          </p>
        </div>

        {/* Email Sending Status */}
        <div
          style={{
            marginBottom: 20,
            padding: "18px",
            background: "#e6f7ff",
            border: "2px solid #91d5ff",
            borderRadius: "10px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            animation: "slideInUp 0.5s ease-out",
          }}
        >
          <div className="email-sending-indicator">
            <span
              style={{
                display: "inline-block",
                width: 12,
                height: 12,
                borderRadius: "50%",
                background: "#1890ff",
                marginRight: 12,
                animation: "pulse 1.5s ease-in-out infinite",
              }}
            ></span>
            <span style={{ color: "#1890ff", fontSize: 16, fontWeight: 500 }}>
              Sending welcome emails and creating accounts...
            </span>
          </div>
        </div>


        {/* Additional Info */}
        <div
          style={{
            marginTop: 20,
            textAlign: "center",
            fontSize: 13,
            color: "#999",
          }}
        >
          <p style={{ margin: 0 }}>
            Please wait while we process all users. This may take a few moments.
          </p>
        </div>
      </div>
    </Modal>
  );
};

export default UploadProgressModal;